import type { IRoute } from '@/shared/models/route.model';
import OnlyUnAuthorizedUserGuard from './guards/OnlyUnAthorizedUserGuard';
import AuthLayout from './layout/AuthLayout';

import { lazy } from 'react';

const SignIn = lazy(() => import('./sign-in/SignIn'));
const ForgetPassword = lazy(() => import('./sign-in/forget-password/ForgetPassword'));

export const authRoutes: IRoute[] = [
  {
    path: '/',
    component: AuthLayout,
    guard: OnlyUnAuthorizedUserGuard,
    children: [
      {
        path: 'sign-in',
        component: SignIn,
      },
      {
        path: 'forgot-pwd',
        component: ForgetPassword,
      },
    ],
  },
];
